import ecFr from "src/brand/EC/i18n/fr.json";
import type { BrandId } from "src/core/constants/brand";
import i18n from "src/core/i18n";

const MESSAGES: Record<BrandId, Record<string, unknown>> = {
  EC: { fr: ecFr },
};

let isBumping = false;

/**
 * Superpose les traductions brand sur "translation".
 * - `bump` = true => on appelle changeLanguage(lng) pour forcer le rerender.
 *   À n'utiliser que depuis le setup initial, pas depuis l'abonné languageChanged.
 */
export async function applyBrandI18n(
  brand: BrandId,
  lng: string,
  options?: { bump?: boolean }
): Promise<void> {
  const perLang = MESSAGES[brand];
  const bundle = perLang?.[lng];
  if (!bundle) return;

  i18n.addResourceBundle(lng, "translation", bundle as object, true, true);
  await i18n.reloadResources([lng], ["translation"]);

  if (options?.bump && !isBumping) {
    try {
      isBumping = true;
      // NB: changeLanguage(lng) re-déclenche languageChanged même si lng identique.
      await i18n.changeLanguage(lng);
    } finally {
      isBumping = false;
    }
  }
}
